<template>
  <div
    :class="[$style.base, { [$style.hasDiscount]: discount }]"
    :style="style"
  >
    {{ timeslot.time }}
    <div
      v-if="totalPrice && discount"
      :class="[
        $style.discountLabel,
        { [$style.increase]: discountType === 'percentage_increase' }
      ]"
    >
      <span :class="$style.labelText">
        {{ label() }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBookingStore } from '@/stores/booking';
import type { TimeSlot } from '@/types';
import widgetSettings from '@/widget-settings';
import { computed } from 'vue';

const props = defineProps<{
  timeslot: TimeSlot;
  isSelected: boolean;
}>();

const { totalPrice } = useBookingStore();

const style = computed(() =>
  props.isSelected
    ? {
        border: `1px solid ${widgetSettings.color}`,
        color: widgetSettings.color
      }
    : {
        color: widgetSettings.color
      }
);

const discount = computed(() =>
  props.timeslot.price_adjustment
    ? props.timeslot.price_adjustment.amount
    : undefined
);
const discountType = computed(() =>
  props.timeslot.price_adjustment
    ? props.timeslot.price_adjustment.adjustment_type
    : ''
);

const label = () =>
  discountType.value === 'percentage_decrease' ? `-${discount.value}%` : '';
</script>

<style lang="scss" module>
.base {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: calc(25% - 9px);
  height: 42px;
  padding-bottom: 2px;
  margin-bottom: 12px;
  background-color: white;
  border-radius: $border-radius;
  cursor: pointer;
  @include box-shadow;

  &:not(:nth-child(4n)) {
    margin-right: 12px;
  }
}

.discountLabel {
  position: absolute;
  top: -8px;
  right: -4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  @include box-shadow('large', 'bottom');
  border-radius: 4px;
  background-color: #2ac77c;
  margin-left: 0.5 * $spacing;
  padding: 2px 4px 3px 4px;
}

.increase {
  background-color: #fd832d;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  top: -6px;
  right: -6px;
}

.labelText {
  color: white;
  font-size: 10px;
  font-weight: bold;
}
</style>
